<section class="main-section">
  <!--
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Orders</li>
      </ol>
    </nav>
  -->
  <div class="row align-items-center">
    <div class="col">
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of ordersMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus)"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
          </li>
        </ng-container>
      </ul>
      <div class="col text-right">
        <button *ngIf="(checkedList?.length)" aria-expanded="false" aria-haspopup="true"
                class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile" data-toggle="dropdown">
          Actions
        </button>
        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right">
          <a (click)="openEscalatePopup()" class="dropdown-item file btn shift-import">Flag</a>
          <a (click)="ReattemptRequestPopupOpen()" class="dropdown-item file btn shift-import">Reattempt</a>
          <a (click)="needActionPopupOpen()" class="dropdown-item file btn shift-import">Request RTO</a>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}" class="inner-box d-none d-sm-block"
           style="min-height:580px!important;">
        <table [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table" datatable>
          <thead>
          <tr>
            <th></th>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th>Order Date</th>
            <th>Sender Name</th>
            <th>Receiver Name</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">

          <tr *ngFor="let o of orders">
            <td>
              <div class="form-checkbox"><input
                (change)="selectShip(o)" [(ngModel)]="o.isSelected" id="{{o.orderHeaderId}}" name="list_name"
                type="checkbox">
                <label for="{{o.orderHeaderId}}"></label></div>
            </td>
            <td><a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></td>
            <td>{{o.sourceOrderId || '--'}}</td>
            <td>{{o.createdDate}}</td>
            <td>{{o.senderName}}</td>
            <td>{{o.receiverName}}</td>
            <td>{{(o?.paymentMethod | replaceStatus) || '--'}}</td>
            <td>
              <div class="text-truncate" style="width:100px;"
                   title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Awaiting Pickup':
                (o.orderStatus == 'SHIPPED' ? 'Shipped':
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus ))))) | replaceStatus}}">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Awaiting Pickup' :
                (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus))))) | replaceStatus}}
              </div>
            </td>
            <td>
              <div
                *ngIf="o.thirdPartyTrackingNum !== null">
                <a routerLink="/trackOutboundOrder/{{o.orderHeaderId}}/{{o.accountOwnerId}}" target="_blank">
                  <img alt="trackImage" height="30" src="assets/images/dsBuffer.png" width="30">
                </a>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td class="text-center" colspan="8">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th style="width: 0px!important;" width="200px;">Order Date</th>
            <th width="200px;">Sender Name</th>
            <th>Receiver Name</th>
            <th *ngIf="user.role==='ACCOUNT_OWNER'" style="width:110px!important;">Payment Method</th>
            <th>Status</th>
          </tr>

          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td>
              <b class=" tablesaw-cell-label">Order #</b>
              <span class="tablesaw-cell-content">
                 <a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Source Order</b><span class="tablesaw-cell-content"> {{o.sourceOrderId || '--'}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Source Data</b><span
              class="tablesaw-cell-content">  {{o.createdDate}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Sender Name</b>
              <span class="tablesaw-cell-content"> {{o.senderName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Receiver Name</b>
              <span class="tablesaw-cell-content">{{o.receiverName}}</span></td>
            <td *ngIf="user.role==='ACCOUNT_OWNER'"><b class=" tablesaw-cell-label">Payment Method</b>
              <span class="tablesaw-cell-content">{{(o?.paymentMethod|replaceStatus) || '--'}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
                <div class="text-truncate" style="width:100px;"
                     title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                  (o.orderStatus == 'SHIPPED' ? 'Shipped':
                  (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                  (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                  (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                  (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus )))))) |replaceStatus}}">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                  (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                    (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                      (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                        (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                          (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus)))))) |replaceStatus}}
                </div>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div [ngClass]="{'modal': needActionPopup == 'Y'}" [ngStyle]="{'display': needActionPopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="needActionPopUp" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="needActionLabe">Return to Origin</h5>
        <button (click)="closeNeedActionPopUp()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <label class="control-label" for="cancelReason">Reason</label>
              <select [(ngModel)]="needActionReason" [ngModelOptions]="{standalone: true}" class="form-control"
                      id="cancelReason" required>
                <option *ngFor="let c of actionReasons" [ngValue]="c.config">{{c.label}}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label" for="description">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}" class="form-control textbox"
                        id="description"
                        required rows="6"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button (click)="closeNeedActionPopUp()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange ml-1" type="submit">Request RTO</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div [ngClass]="{'modal': ReattemptRequestPopup == 'Y'}" [ngStyle]="{'display': ReattemptRequestPopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="ReattemptRequestPopup"
     role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="ReattemptRequest">Reattempt Request</h5>
        <button (click)="closeReattemptRequestPopup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Customer Details</b></h2>
                <div class="row mt-3">
                  <div class="col-lg-4 col-sm-6">
                    <label class="text-black">{{viewCustomer?.ownerName | titlecase}}</label>
                    <label class="text-black">{{viewCustomer?.email}}</label>
                    <label class="text-black">{{viewCustomer?.mobile}}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let add of viewCustomer.adddressList" class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Current Address & Delivery</b></h2>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label class="text-black">{{add.addressType | titlecase}}</label><br>
                    <label class="text-black">{{add.address1}}</label><br>
                    <label class="text-black">{{add.address2}}</label><br>
                    <label class="text-black">{{add.city}}</label><br>
                    <label class="text-black">{{add.state}}</label><br>
                    <label class="text-black">{{add.zip}}</label><br>
                    <label class="text-black"><b>Date</b> : 25-10-2021</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <label class="control-label">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}" class="form-control textbox"
                        id="descriptionR"
                        required rows="6"></textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button (click)="closeReattemptRequestPopup()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange ml-1" type="submit">Request</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': escalatePopup == 'Y'}" [ngStyle]="{'display': escalatePopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="escalatePopup" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="escalatePopupTitle">Flag</h5>
        <button (click)="closeEscalatePopup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}" class="form-control textbox"
                        id="descriptionE"
                        required rows="6"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button (click)="closeEscalatePopup()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange ml-1" type="submit">Flag</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

